/*global $, document, window, setTimeout, alert, typeof, location, confirm*/
(function () {
    "use strict";

    FG.Utils = {
        init: function () {
            this.initDelete();
        },
        initDelete: function () {
            $("a.delete").click(function () {
                if (confirm('are you sure?')) {
                    $.ajax({
                        'url': $(this).attr('href'),
                        'type': 'DELETE',
                        'dataType': 'json',
                        'success': function (resp) {
                            if (resp.location) {
                                location.href = resp.location;
                            } else {
                                location.reload();
                            }
                        },
                        'error': function (resp) {
                            alert('sorry, cannot delete: ');
                        }
                    });
                }
                return false;
            });
        },
        showSuccess: function (divId, successMsg) {
            $('#' + divId).html(successMsg).show().removeClass('alert-error').addClass('alert alert-success').fadeIn('slow');
        },
        showError: function (divId, errorMessage) {
            $('#' + divId).html(errorMessage).show().removeClass('alert-success').addClass('alert alert-error').fadeIn('slow');
        },
        getCountryCode: function(selector) {
            var countryCode = $(selector).find('.iti__selected-country').attr('title');
            return countryCode ? countryCode.split(':')[1].trim() : null;
        }
    };
}());